// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { useCallback } from 'react';
import { useAppDispatch } from 'store/hooks';
import { LockedActionIntent } from 'store/reducers/projectLockedSlice';
import { setResetModelId } from 'store/reducers/projectModelResetSlice';
import { setEditId } from 'store/reducers/projectSettingsSlice';
import { fetchProjects } from 'store/reducers/projectsSlice';
import { useProjectLockApi } from './useProjectLockApi';

// edit and model reset need the lock, history fetch answers 423 otherwise
export default function useOpenProjectWithLock() {
  const dispatch = useAppDispatch();
  const { lock, loading } = useProjectLockApi();

  const openProjectWithLock = useCallback(
    async (projectId: string, intent: LockedActionIntent, refreshProjects = true) => {
      const locked = await lock(projectId, intent);
      if (!locked) return false;

      if (refreshProjects) dispatch(fetchProjects());

      if (intent === 'resetModel') dispatch(setResetModelId(projectId));
      else dispatch(setEditId(projectId));

      return true;
    },
    [dispatch, lock]
  );

  return { openProjectWithLock, loading };
}
